import * as yup from 'yup';
import { ObjectSchema } from 'yup';

import { CustomScheduleExpectationFormValues } from '@/forms/CustomScheduleExpectationForm/types';

const optionType = (label: string) =>
  yup.object({
    label: yup.string().default(''),
    value: yup.string().required().label(label)
  });

export const customScheduleExpectationSchema: ObjectSchema<CustomScheduleExpectationFormValues> =
  yup.object({
    appointment_type: optionType('Appointment type').required(),
    cycle_time: yup.string().label('Cycle time').required(),
    frequency: yup.string().label('Frequency').required(),
    look_ahead_cycles: optionType('Checking for scheduling').required(),
    max_attendances: yup.string().default(null),
    note: yup.string().nullable().default(null),
    phase: yup.string().required(),
    start_at: yup
      .string()
      .label('Schedule start date')
      .required('Schedule start date is a required field'),
    time_unit: yup.string().label('Time unit').required()
  });
